/* Wildlight Honey — motion & contrast layer.
   Everything checks prefers-reduced-motion and degrades to static content. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raf = window.requestAnimationFrame.bind(window);

  /* ============ 1. Wordmark =================================================
     The shop is still named "My Store 2" in Shopify settings, which the theme
     prints as the logo. Until that is renamed in admin, draw the real mark.
     Built from live text + an SVG skep so it inherits the header colour and
     flips automatically with the dynamic contrast below. */
  var SKEP = '<svg class="wh-logo__skep" viewBox="0 0 40 34" aria-hidden="true" focusable="false">' +
    '<g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">' +
    '<path d="M6.5 29.5h27"/>' +
    '<path d="M8.5 25.2c0-1.2 23-1.2 23 0"/>' +
    '<path d="M9.2 20.6c1.6-1.6 20-1.6 21.6 0"/>' +
    '<path d="M10.6 16c1.9-1.9 16.9-1.9 18.8 0"/>' +
    '<path d="M12.6 11.6c1.9-1.8 12.9-1.8 14.8 0"/>' +
    '<path d="M15.4 7.6C16.6 6.2 23.4 6.2 24.6 7.6"/>' +
    '<path d="M18.4 4.4c.7-.9 2.5-.9 3.2 0"/>' +
    '</g>' +
    '<ellipse cx="20" cy="29.5" rx="3.1" ry="2.4" fill="currentColor"/></svg>';

  function wordmark() {
    var links = document.querySelectorAll(
      '.header__heading-link, .header__heading a, h1.header__heading > a, .header__logo a');
    links.forEach(function (a) {
      if (a.dataset.whLogo) return;
      var txt = (a.textContent || '').trim();
      if (a.querySelector('img')) return;            // a real logo image is set — leave it alone
      if (a.querySelector('svg') && !/my store/i.test(txt)) return;
      a.dataset.whLogo = '1';
      a.innerHTML = '<span class="wh-logo">' + SKEP +
        '<span class="wh-logo__word"><span class="wh-logo__name">Wildlight Honey</span>' +
        '<span class="wh-logo__sub">Georgia</span></span></span>';
    });
  }

  /* ============ 2. Dynamic header contrast ==================================
     Works out what is actually behind the header and flips the header between
     light and dark type. Sections can declare themselves with data-wh-tone. */
  function luminance(rgb) {
    var m = rgb && rgb.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    if (p.length > 3 && p[3] < 0.35) return null;          // effectively transparent
    var f = p.slice(0, 3).map(function (v) {
      v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * f[0] + 0.7152 * f[1] + 0.0722 * f[2];
  }

  function toneOf(el) {
    while (el && el !== document.body) {
      if (el.dataset && el.dataset.whTone) return el.dataset.whTone;
      var cs = getComputedStyle(el);
      // a covering image or video: treat as dark, heroes carry overlays
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'dark';
      var l = luminance(cs.backgroundColor);
      if (l !== null) return l < 0.42 ? 'dark' : 'light';
      el = el.parentElement;
    }
    return 'light';
  }

  function headerContrast() {
    var hdr = document.querySelector('.section-header, #shopify-section-header, .header-wrapper');
    if (!hdr) return;
    var tone = null;

    /* If the header paints its own opaque surface, what sits behind it is
       irrelevant — decide from the bar itself. Probing behind an opaque header
       is what made the nav render cream-on-cream on the inner pages. */
    var el = hdr, guard = 0;
    while (el && guard++ < 4) {
      var bg = getComputedStyle(el).backgroundColor;
      var m = bg && bg.match(/rgba?\(([^)]+)\)/);
      if (m) {
        var parts = m[1].split(',').map(parseFloat);
        var alpha = parts.length > 3 ? parts[3] : 1;
        if (alpha >= 0.5) { var l = luminance(bg); if (l !== null) { tone = l < 0.42 ? 'dark' : 'light'; } break; }
      }
      el = el.firstElementChild;
    }

    if (tone === null) {
      // transparent header: fall through to whatever section is underneath
      var h = hdr.getBoundingClientRect().height || 70;
      var x = Math.round(window.innerWidth / 2);
      var probe = document.elementFromPoint(x, Math.min(h + 8, window.innerHeight - 2));
      if (probe && hdr.contains(probe)) probe = document.elementFromPoint(x, Math.min(h + 48, window.innerHeight - 2));
      if (probe) {
        var sec = probe.closest('[data-wh-tone], .shopify-section, section');
        if (sec && sec.dataset && sec.dataset.whTone) tone = sec.dataset.whTone;
        else if (sec && sec.querySelector('.slideshow, .slideshow__media, .banner__media, .banner__media-image, video')) tone = 'dark';
        else tone = toneOf(probe);
      } else tone = 'light';
    }

    hdr.classList.toggle('wh-hd-light', tone === 'dark');
    hdr.classList.toggle('wh-hd-dark', tone !== 'dark');
    document.documentElement.classList.toggle('wh-scrolled', window.scrollY > 12);
  }

  /* ============ 3. Scroll reveals =========================================== */
  function autoTag() {
    /* Deliberately narrow. An earlier version matched '.section-header', which
       in this theme is the site header itself, and animated the navigation to
       opacity 0. Only content cards are auto-tagged now. */
    var sels = ['.collection-list__item', '.card-wrapper', '.multicolumn-card'];
    document.querySelectorAll(sels.join(',')).forEach(function (el, i) {
      if (el.classList.contains('wh-reveal')) return;
      if (el.closest('.wh-marquee, .header-wrapper, .shopify-section-group-header-group, .shopify-section-group-footer-group')) return;
      el.classList.add('wh-reveal');
      var d = i % 3; if (d) el.classList.add('wh-d' + d);
    });
    document.querySelectorAll('.wh-story__heading').forEach(function (h) {
      h.classList.add('wh-sweep');
    });
  }

  /* Last-resort safety net: anything still hidden after this point is shown,
     whatever happened to the observer. */
  function revealAll() {
    document.querySelectorAll('.wh-reveal:not(.is-in)').forEach(function (n) {
      n.classList.add('is-in');
    });
  }

  function reveals() {
    var nodes = document.querySelectorAll('.wh-reveal:not(.is-in)');
    if (!nodes.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { rootMargin: '200px 0px 0px 0px', threshold: 0.01 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ============ 4. Honeycomb fill ===========================================
     Cells fill bottom-up as the section crosses the viewport, with enough
     scatter that it reads as liquid finding its level. */
  function comb() {
    document.querySelectorAll('[data-wh-comb]').forEach(function (sec) {
      var cells = [].slice.call(sec.querySelectorAll('.wh-comb__cell'));
      if (!cells.length) return;
      if (!sec.dataset.whCombReady) {
        var maxR = Math.max.apply(null, cells.map(function (c) { return +c.dataset.r; }));
        cells.forEach(function (c) {
          var r = +c.dataset.r, col = +c.dataset.c;
          // bottom rows first, with a deterministic jitter so it is not a wipe
          var jitter = (Math.sin(r * 12.9898 + col * 78.233) * 43758.5453) % 1;
          c._key = (maxR - r) / (maxR + 1) + Math.abs(jitter) * 0.34 + col * 0.004;
        });
        cells.sort(function (a, b) { return a._key - b._key; });
        sec.dataset.whCombReady = '1';
        sec._cells = cells;
      }
      var list = sec._cells || cells;
      if (reduce.matches) { list.forEach(function (c) { c.style.setProperty('--f', 0.12); }); return; }
      var r0 = sec.getBoundingClientRect(), vh = window.innerHeight;
      // 0 when the section's top reaches the bottom of the screen, 1 once it is nearly out
      var p = (vh - r0.top) / (vh + r0.height * 0.55);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * list.length);
      var MAX = 0.42;   // never solid — this is a texture, not a curtain
      list.forEach(function (c, i) {
        c.style.setProperty('--f', i < n ? (MAX * (0.45 + 0.55 * (1 - i / list.length))).toFixed(3) : 0);
      });
    });
  }

  /* ============ 5. Honey scroll progress ==================================== */
  function progress() {
    return;   // retired with the pollen — extra chrome, no job to do
    /* eslint-disable no-unreachable */
    if (reduce.matches) return;
    var bar = document.getElementById('wh-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'wh-progress';
      bar.innerHTML = '<span class="wh-progress__fill"></span><span class="wh-progress__bead"></span>';
      document.body.appendChild(bar);
    }
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(1, window.scrollY / h) : 0;
    bar.style.setProperty('--p', (p * 100).toFixed(2) + '%');
  }

  /* ============ 6. Parallax ================================================= */
  var parallaxItems = [];
  function collectParallax() { parallaxItems = [].slice.call(document.querySelectorAll('.wh-parallax')); }
  function parallax() {
    if (reduce.matches || !parallaxItems.length) return;
    var vh = window.innerHeight;
    parallaxItems.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var prog = (r.top + r.height / 2 - vh / 2) / vh;
      var depth = parseFloat(el.dataset.depth || '14');
      el.style.transform = 'translate3d(0,' + (-prog * depth).toFixed(2) + 'px,0)';
    });
  }

  /* ============ 7. Pollen =================================================== */
  function pollen() {
    return;   // retired: the brief is clean and simple, and drifting motes read as noise
    /* eslint-disable no-unreachable */
    if (reduce.matches || window.innerWidth < 900) return;
    if (document.getElementById('wh-pollen')) return;
    var c = document.createElement('canvas'); c.id = 'wh-pollen';
    document.body.appendChild(c);
    var ctx = c.getContext('2d'), motes = [], W, H, id;
    function size() { W = c.width = innerWidth * devicePixelRatio; H = c.height = innerHeight * devicePixelRatio; }
    function seed() {
      motes = [];
      var n = Math.min(30, Math.round(innerWidth / 55));
      for (var i = 0; i < n; i++) motes.push({
        x: Math.random() * W, y: Math.random() * H,
        r: (Math.random() * 1.5 + .45) * devicePixelRatio,
        vx: (Math.random() - .5) * .14 * devicePixelRatio,
        vy: (-Math.random() * .2 - .04) * devicePixelRatio,
        a: Math.random() * .42 + .14, t: Math.random() * 6.28
      });
    }
    function tick() {
      ctx.clearRect(0, 0, W, H);
      motes.forEach(function (m) {
        m.t += .01; m.x += m.vx + Math.sin(m.t) * .14 * devicePixelRatio; m.y += m.vy;
        if (m.y < -12) { m.y = H + 10; m.x = Math.random() * W; }
        if (m.x < -12) m.x = W + 10; else if (m.x > W + 12) m.x = -10;
        var g = ctx.createRadialGradient(m.x, m.y, 0, m.x, m.y, m.r * 3.2);
        g.addColorStop(0, 'rgba(242,208,138,' + m.a + ')');
        g.addColorStop(1, 'rgba(214,147,39,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(m.x, m.y, m.r * 3.2, 0, 6.283); ctx.fill();
      });
      id = raf(tick);
    }
    size(); seed(); tick();
    addEventListener('resize', function () { size(); seed(); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cancelAnimationFrame(id); else tick();
    });
  }

  /* ============ 8. Marquee ================================================== */
  function marquees() {
    document.querySelectorAll('.wh-marquee__track:not([data-doubled])').forEach(function (t) {
      t.setAttribute('data-doubled', '1'); t.innerHTML += t.innerHTML;
    });
  }

  /* ============ loop ======================================================== */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    raf(function () { headerContrast(); comb(); progress(); parallax(); ticking = false; });
  }

  /* ============ 8b. Make the card photograph clickable =====================
     The theme wraps only the TITLE in a link, so the image was dead to a click.
     A stretched ::after depends on which ancestor happens to be positioned, so
     instead wrap the media in a real anchor — middle-click and open-in-new-tab
     work properly. It is aria-hidden and untabbable, so assistive tech and the
     keyboard still see exactly one link per card. */
  function cardLinks() {
    document.querySelectorAll('.card-wrapper, .collection-card-wrapper').forEach(function (card) {
      var media = card.querySelector('.card__media, .card__inner');
      if (!media || media.closest('a') || media.dataset.whLinked) return;
      var src = card.querySelector('.card__heading a, a.full-unstyled-link');
      if (!src || !src.getAttribute('href')) return;
      media.dataset.whLinked = '1';
      var a = document.createElement('a');
      a.className = 'wh-card-link';
      a.setAttribute('href', src.getAttribute('href'));
      a.setAttribute('tabindex', '-1');
      a.setAttribute('aria-hidden', 'true');
      media.parentNode.insertBefore(a, media);
      a.appendChild(media);
    });
  }

  /* ============ 9. Drawer-aware header =====================================
     When the mobile menu or cart drawer opens it paints a cream surface that
     extends up behind the header bar. The header's light-on-dark overrides then
     make the logo and icons invisible, so flag the header for the duration. */
  function drawerWatch() {
    var hdr = document.querySelector('.section-header, #shopify-section-header, .header-wrapper');
    if (!hdr) return;
    function sync() {
      var open = !!document.querySelector(
        'details.menu-drawer-container[open], header-drawer details[open], ' +
        '.menu-drawer-container.menu-opening, cart-drawer.active, .drawer.active, .js-drawer-open');
      hdr.classList.toggle('wh-drawer-open', open);
    }
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);
    document.addEventListener('keyup', function () { setTimeout(sync, 60); }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(document.documentElement, {
        subtree: true, attributes: true, attributeFilter: ['open', 'class']
      });
    }
    sync();
  }

  function init() {
    wordmark(); cardLinks(); autoTag(); reveals(); marquees(); drawerWatch();
    collectParallax(); pollen();
    headerContrast(); comb(); progress(); parallax();
    addEventListener('scroll', onScroll, { passive: true });
    /* The theme paints the header background after our first pass, and on a page
       the visitor never scrolls headerContrast() would never run again — which
       left the nav cream-on-cream on inner pages. Re-check once things settle. */
    [120, 400, 1200].forEach(function (d) { setTimeout(headerContrast, d); });
    addEventListener('load', function () { headerContrast(); setTimeout(headerContrast, 300); });
    addEventListener('resize', function () { collectParallax(); onScroll(); }, { passive: true });
  }

  /* ?wh_debug=1 reports layout overflow into document.title, so a headless
     render can tell us exactly which element is wider than the viewport. */
  function whDebug() {
    if (location.search.indexOf('wh_debug') === -1) return;
    setTimeout(function () {
      var vw = document.documentElement.clientWidth, bad = [];
      document.querySelectorAll('body *').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width > vw + 1 || r.right > vw + 1 || r.left < -1) {
          bad.push((el.tagName.toLowerCase() +
            '.' + String(el.className || '').split(' ').filter(Boolean).slice(0, 2).join('.')) +
            '[w' + Math.round(r.width) + ',l' + Math.round(r.left) + ',r' + Math.round(r.right) + ']');
        }
      });
      document.title = 'VW' + vw + ' SW' + document.documentElement.scrollWidth +
                       ' :: ' + bad.slice(0, 14).join(' | ');
    }, 2500);
    /* ?wh_debug=links checks that a click on each card IMAGE lands on a link,
       not just the title. */
    if (location.search.indexOf('wh_debug=links') !== -1) {
      setTimeout(function () {
        var out = [], ok = 0, bad = 0;
        document.querySelectorAll('.card-wrapper .card__media img, .wh-var__media img').forEach(function (img) {
          var r = img.getBoundingClientRect();
          if (r.width < 8 || r.bottom < 0 || r.top > innerHeight) return;
          var hit = document.elementFromPoint(r.left + r.width / 2, Math.max(2, Math.min(r.top + r.height / 2, innerHeight - 2)));
          var a = hit && hit.closest ? hit.closest('a') : null;
          if (a) { ok++; } else {
            bad++;
            var d = hit ? (hit.tagName.toLowerCase() + '.' +
                  String(hit.className || '').split(' ').filter(Boolean).slice(0,2).join('.')) : 'null';
            var hh = img.closest('.card-wrapper, .wh-var__card');
            var link = hh ? hh.querySelector('.card__heading a, .wh-var__media--link') : null;
            var lr = link ? link.getBoundingClientRect() : null;
            out.push((img.alt||'?').slice(0,14) + '[hit=' + d +
                     (lr ? ' linkbox=' + Math.round(lr.width) + 'x' + Math.round(lr.height) : ' nolink') + ']');
          }
        });
        document.title = 'CARDS clickable=' + ok + ' dead=' + bad + (out.length ? ' :: ' + out.join(',') : '');
      }, 2600);
    }

    /* ?wh_debug=shop opens the desktop Shop dropdown so it can be screenshotted */
    if (location.search.indexOf('wh_debug=shop') !== -1) {
      setTimeout(function () {
        var d = document.querySelector('.header__inline-menu details, header-menu details');
        if (d) { d.setAttribute('open', ''); d.classList.add('menu-opening'); }
        var sub = document.querySelector('.header__submenu');
        if (sub) { sub.style.opacity = '1'; sub.style.visibility = 'visible'; sub.style.transform = 'none'; }
      }, 1000);
    }

    /* ?wh_debug=menu forces the mobile drawer open so a headless render can
       check its contrast — it cannot click. */
    if (location.search.indexOf('wh_debug=menu') !== -1) {
      setTimeout(function () {
        var d = document.querySelector('details.menu-drawer-container, header-drawer details, .header__icon--menu');
        if (d && d.tagName === 'DETAILS') { d.setAttribute('open', ''); d.classList.add('menu-opened'); }
        var dr = document.querySelector('.menu-drawer');
        if (dr) { dr.style.transform = 'translate(0)'; dr.style.visibility = 'visible'; dr.style.opacity = '1'; }
      }, 1200);
    }
  }
  whDebug();

  document.documentElement.classList.add('wh-js');   // enables the hidden state
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // if anything at all goes wrong, show the page rather than a blank cream void
  addEventListener('load', function () { setTimeout(revealAll, 1200); });
  setTimeout(revealAll, 5000);
  document.addEventListener('shopify:section:load', function () {
    wordmark(); cardLinks(); autoTag(); reveals(); marquees(); collectParallax(); onScroll();
  });
})();
